import { render, staticRenderFns } from "./LifestyleGoalsTab.vue?vue&type=template&id=e053c3d2&scoped=true&"
import script from "./LifestyleGoalsTab.vue?vue&type=script&lang=js&"
export * from "./LifestyleGoalsTab.vue?vue&type=script&lang=js&"
import style0 from "./LifestyleGoalsTab.vue?vue&type=style&index=0&id=e053c3d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e053c3d2",
  null
  
)

export default component.exports